import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import { showNotification } from "Common/utils/Notification";
import BreadCrumb from "Common/BreadCrumb";
import { PaginationState } from "@tanstack/react-table";
import TableContainer from "Common/TableContainer";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Search, Trash2, Pencil, Download } from "lucide-react";
import DeleteModal from "Common/DeleteModal";
import callApi from "Common/utils/apiCaller";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import _ from "lodash";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { getImageUrl } from "Common/utils/ImageDomain";

import "flatpickr/dist/flatpickr.min.css";
import moment from "moment";
import Select from "react-select";
import indexYield from "../../constants/indexYield.json";
import FileUpload from "Common/Components/InputFields/FileUploadBtn";

const IndexUpload = () => {
  const navigate = useNavigate();
  const [edit, setEdit] = useState<any>();
  const [index, setIndex] = useState([]);
  const [search, setSearch] = useState<any>();
  const [showModel, setShowModel] = useState<boolean>(false);
  const [read, setRead] = useState<any>();
  const defaultToggle = () => setShowModel(!showModel);
  const [imageLink, setImageLink] = useState<any>("");
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [option, setOption] = useState<any>([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [published, setPublished] = useState<any>();
  const [filters, setFilters] = useState<any>();

  const [indexCode, setIndexCode] = useState<any>();

  const [files, setFiles] = useState<any>({
    indexYieldFile: null,
  });
  const [errors, setErrors] = useState<any>({});
  const [id, setId] = useState<any>();
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const deleteToggle = () => setDeleteModal(!deleteModal);

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setPublished(null);
    } else if (selectedOption.value === "UnPublished") {
      let value1: boolean = false;
      setPublished(value1);
    } else if (selectedOption.value === "Published") {
      let value1: boolean = true;
      setPublished(value1);
    }
  };

  const debouncedHandler = useCallback(
    _.debounce((user: any, render: any, pagination: any) => {
      return fetchDateWithFilters(user, render, pagination);
    }, 700),
    []
  );

  // useEffect(() => {
  //   fetchData("edit_code");
  // }, []);

  // const fetchData = async (code) => {
  //   try {
  //     const res = await callApi(`v1/content/code/${code}`, "get", {});
  //     if (res.status === "Success") {
  //       setOption(res.data.content.params);
  //     }
  //   } catch (e) {
  //     showNotification("Error occured", "error");
  //   }
  // };

  async function fetchDateWithFilters(
    searchByName: any,
    render: any,
    pagination: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }

    const localData = await callApi("v1/indexupload/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    let arr = [];
    if (localData?.status === "Success") {
      setIndex([...localData.data.indexuploadList]);
      setPageCount(
        Math.ceil(localData.data.indexuploadCount / pagination.pageSize)
      );
      setTotalItems(localData.data.indexuploadCount);
    }
  }

  const filterSearchData = (e: any) => {
    const search = e.target.value;

    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, render, pagination);
  }, [search, render, pagination]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

      interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");

  const premissionInfo: PermissionInfo | null = rawPermission
    ? JSON.parse(rawPermission)
    : null;

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));

      const res = await callApi(
        `v1/indexupload/${eventData?._id}/update`,
        "post",
        {
          indexupload: { is_deleted: true },
        }
      );
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };

  const handleEditChange = (selectedOption: any) => {
    if (selectedOption.value === "select") {
      setEdit(null);
    } else if (selectedOption.value === "unedit") {
      let value1: boolean = false;
      setEdit(value1);
    } else if (selectedOption.value === "edit") {
      let value1: boolean = true;
      setEdit(value1);
    }
  };

  const indexColumns = useMemo(
    () => [
      // {
      //   header: "Base Date",
      //   accessorKey: "base_date",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: (cell) => <>{moment(cell.getValue()).format("DD MMM YY ")}</>,
      // },
      {
        header: "File Name",
        accessorKey: "file_name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium">
                {cell.row.original?.file_name}
              </span>
              <button
                onClick={() =>
                  window.open(
                    getImageUrl(cell.row.original?.file_url),
                    "_blank"
                  )
                }
                className="flex items-center gap-1 text-sm text-blue-500 hover:text-blue-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download
              </button>
            </div>
          </>
        ),
      },
      {
        header: "Uploaded By",
        accessorKey: "uploaded_by",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => cell.row.original?.uploaded_by?.contact_name,
      },
      {
        header: "Uploaded At",
        accessorKey: "created_at",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) =>
          moment(cell.row.original?.created_at).format("DD MMM YY"),
      },
      // {
      //   header: "Thumbnail Url",
      //   accessorKey: "thumbnail_url",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: (cell: any) => (
      //     <Link
      //       to={getImageUrl(cell.row.original.thumbnail_url)}
      //       className="flex items-center gap-3 "
      //       target="_blank"
      //     >
      //       <div className="rounded-full size-6 shrink-0 bg-slate-100">
      //         <img
      //           src={getImageUrl(cell.row.original.thumbnail_url)}
      //           alt=""
      //           className="h-6 rounded-full"
      //         />
      //       </div>
      //     </Link>
      //   ),
      // },

      {
        header: "Model Type",
        accessorKey: "model_type",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Upload Status",
        accessorKey: "is_processed",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) =>
          cell.row.original?.is_processed ? "Completed" : "Not Completed",
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            {/* <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["index:read"]}
              yes={
                <div
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md cursor-pointer size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    navigate(`${INDEX_UPDATE_ROUTE.replace(":id", data._id)}`);
                  }}
                >
                  <Pencil className="size-4" />
                </div>
              }
              no={<span></span>}
            /> */}
            <div className="flex gap-3">
              <PermissionSwitch
                hasPermissions={premissionInfo?.permissions ?? []}
                shouldHavePermissions={["indexupload:delete"]}
                yes={
                  <Link
                    to="#!"
                    className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                    onClick={() => {
                      const data = cell.row.original;
                      onClickDelete(data);
                    }}
                  >
                    <Trash2 className="size-4" />
                  </Link>
                }
                no={<span></span>}
              />
            </div>
          </div>
        ),
      },
    ],
    []
  );

  const handleDownloadValueSample = async () => {
    let arr = [];

    const rows = [["index_name", "code", "yield"]];

    let csvContent = "";

    indexYield?.forEach((e) => {
      rows.push([e.index_name, e.code, e.yield.toString()]);
    });

    rows.forEach((rowArray) => {
      let row = rowArray.join(",");
      csvContent += row + "\n";
    });
    let contentType = "text/csv";
    let filename = `${`index_yield_sample`}.csv`;

    if (!contentType) contentType = "application/octet-stream";
    var a = document.createElement("a");
    var blob = new Blob([csvContent], { type: contentType });
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
  };

  const downloadYieldSample = async () => {
    await toast.promise(
      () => handleDownloadValueSample(),
      {
        pending: "Downloading",
        success: "File downloaded 👌",
        error: "Failed to download 🤯",
      },
      {
        hideProgressBar: true,
      }
    );
  };

  const getUploadStateDone = () => {
    setRender(!render);
  };

  const downloadIndexData = async () => {
    if (!indexCode) {
      toast.error("Please enter index code");
      return;
    }
    const res = await callApi(
      "v1/index/download-index-data-by-code",
      "post",
      { index_code: indexCode }
    );
    downloadReturnType(res, `${indexCode}`);
  };


  const downloadReturnType = async (csvString: string, filename: string): Promise<void> => {
    try {
      await toast.promise(
        new Promise<void>((resolve, reject) => {
          try {
            downloadCSV(csvString, filename);
            resolve();
          } catch (error) {
            reject(error);
          }
        }),
        {
          pending: "Downloading...",
          success: "File downloaded 👌",
          error: "Failed to download 🤯",
        },
        {
          hideProgressBar: true,
        }
      );
    } catch (e) {
      showNotification("Download failed", "error");
    }
  };


  const downloadCSV = (csvString, filename) => {
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  return (
    <>
      <React.Fragment>
        <BreadCrumb
          title={`${"IndexUpload"} `}
          pageTitle={`${"IndexUpload"} `}
          version=""
        />
        <DeleteModal
          show={deleteModal}
          onHide={deleteToggle}
          onDelete={handleDelete}
        />
        <ToastContainer closeButton={false} limit={1} />
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="flex justify-end gap-4 py-4 mr-4">
              <input
                type="text"
                className="form-input w-1/4"
                placeholder="Enter Index Code"
                onChange={(e) => setIndexCode(e.target.value)}
                value={indexCode}
              />
              <button
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={() => downloadIndexData()}
              >
                <Download className="inline-block size-4" />{" "}
                <span className="align-middle">Download Index Data</span>
              </button>
              <button
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={() => downloadYieldSample()}
              >
                <Download className="inline-block size-4" />{" "}
                <span className="align-middle">Download Yield File</span>
              </button>
              <div>
                <FileUpload
                  label=""
                  name="indexYieldFile"
                  files={files}
                  id={id}
                  setFiles={setFiles}
                  errors={errors}
                  setErrors={setErrors}
                  allowedTypes={["text/csv"]}
                  getUploadStateDone={getUploadStateDone}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">IndexUpload List</h6>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-3">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for file name..."
                      autoComplete="off"
                      onChange={(e) => filterSearchData(e)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                  {/* <div className="xl:col-span-2">
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={options}
                      isSearchable={false}
                      defaultValue={options[0]}
                      onChange={(event: any) => handleChange(event)}
                      id="choices-single-default"
                    />
                  </div>
                  {option?.length !== 0 && (
                    <div className="xl:col-span-2">
                      <Select
                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        options={option}
                        isSearchable={false}
                        defaultValue={option[0]}
                        onChange={(event: any) => handleEditChange(event)}
                        id="choices-single-default"
                      />
                    </div>
                  )} */}
                  {/* <div className="xl:col-span-2">
                      <Select
                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        options={options}
                        isSearchable={false}
                        defaultValue={options[0]}
                        onChange={(event: any) => handleChange(event)}
                        id="choices-single-default"
                      />
                    </div> */}
                  {/* <div className="xl:col-span-3 xl:col-start-10">
                    <div className="flex gap-2 xl:justify-end">
                      <Flatpickr
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        options={{
                          dateFormat: "d M, Y",
                          mode: "range",
                        }}
                        placeholder="Select date range"
                        name="date"
                        onChange={(date) => {
                          date.length > 1 &&
                            setFilters((e) => ({
                              ...e,
                              startDate: date[0],
                              endDate: date[1],
                            }));
                        }}
                      />
                    </div>
                  </div> */}
                </div>
              </form>
            </div>
            <div className="card-body">
              <TableContainer
                isPagination={true}
                columns={indexColumns || []}
                data={index || []}
                pageCount={pageCount}
                pagination={pagination}
                totalItems={totalItems}
                onPaginationChange={(updater: any) => {
                  const nextState = updater(pagination);
                  if (nextState.pageIndex !== pagination.pageIndex)
                    setPagination(nextState);
                }}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    </>
  );
};

export default IndexUpload;
